import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid2'

import { ProgressCard } from '../cards/ProgressCard';
import { LabeledProgressCard } from '../cards/LabeledProgressCard';
import { ProductSegmentCard } from '../cards/ProductSegmentCard';
import {
  transformProgressData,
  transformBulkOrderBreakdownData,
  transformProductSegmentData,
  transformGoupedColumn,
} from '../dash-util';
import DualAxisColumn from '../charts/DualAxisColumn';

export const FinanceView = ({ cardsData, productData, regressionData, periodFilter, setPeriodFilter }) => {

  const [finGroupedColumn, setFinGroupedColumn] = useState([]);
  const [showGroupedLegend, setShowGroupedLegend] = useState(false);

  useEffect(() => {
    const grouped = transformGoupedColumn(regressionData);
    setFinGroupedColumn(grouped);

    const showLegend = !grouped.series.every((item) => item.data.length === 0);
    setShowGroupedLegend(showLegend);

  }, [cardsData, regressionData, productData, periodFilter]);

  return (
    <>
    <Grid container spacing={3}>
      <Grid size={{ lg: 3, sm: 6, xs: 12 }} key='Revenue Expected'>
        <ProgressCard
          sx={{ height: '100%' }}
          data={transformProgressData(cardsData, 'Revenue Expected')}
        />
      </Grid>

      <Grid size={{ lg: 3, sm: 6, xs: 12 }} key='Revenue Loss'>
        <ProgressCard
          sx={{ height: '100%' }}
          data={transformProgressData(cardsData, 'Revenue Loss')}
        />
      </Grid>

      <Grid size={{ lg: 3, sm: 6, xs: 12 }} key='Revenue Generated'>
        <ProgressCard
          sx={{ height: '100%' }}
          data={transformProgressData(cardsData, 'Revenue Generated')}
        />
      </Grid>
      
      <Grid size={{ lg: 3, sm: 6, xs: 12 }} key={"Bulk-Breakdown"}>
        <LabeledProgressCard
          isOpenTooltip
          data={transformBulkOrderBreakdownData(cardsData)}
          sx={{ height: '100%' }}
        />
      </Grid>
    </Grid>

    <Grid container spacing={3} sx={{mt: 3}}>
      <Grid size={{ xs: 8 }} key="stakked-product-segment">
      <DualAxisColumn
        chartConfigs={finGroupedColumn}
        height={350}
        title={"Order Tracking"}
        periodFilter={periodFilter}
        setPeriodFilter={setPeriodFilter}
        showLegend={showGroupedLegend}
      />
      </Grid>

      <Grid size={{ xs: 4 }} key="product segment">
        <ProductSegmentCard
          products={transformProductSegmentData(productData)}
          periodFilter={periodFilter}
          setPeriodFilter={setPeriodFilter}
          sx={{ height: '100%' }}
        />
      </Grid>
    </Grid>
  </>
  )
}

FinanceView.propTypes = {
  cardData: PropTypes.arrayOf(PropTypes.object).isRequired,
}
